import { ethers } from "ethers";
import { Action, Actions, Helpers, Thunk } from "easy-peasy";
import { AbiService } from "./lib/abi";
import { AppService } from "./lib/AppService";

export enum AppStatus {
  Disconnected,
  NotStarted,
  Connected,
}

export enum AppError {
  NoEthereum = "NoEthereum",
  WrongNetwork = "WrongNetwork",
  UserDeniedTransaction = "UserDeniedTransaction",
  RequestAlreadyPending = "RequestAlreadyPending",
  UnrecognizedError = "UnrecognizedError",
}

export interface EthereumService {
  error?: AppError;
  mintedCount: number;
  wallet?: string;
  provider?: ethers.providers.BaseProvider;

  /**
   * ABI используемое для чтения, как провайдер используется Infura
   */
  abi?: AbiService;

  /**
   * ABI, использумое для записи (метод buy)
   */
  writableAbi?: AbiService;

  init(): Promise<AppStatus>;

  connect(): Promise<AppStatus | undefined>;

  buy(amount: number): Promise<any>;

  amountToBn(n: number): any;
}

export interface StoreModel {
  wallet?: string;
  mintedCount: number;
  tokenPrice?: string;
  setMintedCount: Action<StoreModel, number>;
  setTokenPrice: Action<StoreModel, string>;
  setWallet: Action<StoreModel, string>;
  status: AppStatus;
  errors: AppError[];
  setStatus: Action<StoreModel, AppStatus>;
  setErrors: Action<StoreModel, AppError[]>;
  init: Thunk<StoreModel, undefined, StoreInjections>;
  connect: Thunk<StoreModel, undefined, StoreInjections>;
  switchToPolygon: Thunk<StoreModel, undefined, StoreInjections>;
  disconnect: Thunk<StoreModel, undefined, StoreInjections>;
  buy: Thunk<StoreModel, number, StoreInjections>;
  mintFreeOne: Thunk<StoreModel, undefined, StoreInjections>;
  mintRef: Thunk<StoreModel, { amount: number; ref: string }, StoreInjections>;
}

export interface StoreInjections {
  AppService: AppService;
}

type StoreActions = Actions<StoreModel>;
type StoreHelpers = Helpers<StoreModel, StoreModel, StoreInjections>;
export type StoreFn<T> = (
  actions: StoreActions,
  payload: T,
  helpers: StoreHelpers
) => any;

export interface AlchemyProvider {
  network: string;
  apiKey: string;
}
